const ROUTEPATH = {
  //Auth
  AUTH: {
    LOGIN: "/auth/login",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
  },

  //Main
  USERS: {
    USERS_LIST: "users/",
    ARCHIVED_USERS_LIST: "/users/archived",
    CREATE_ADMIN: "/users/create-admin",
    USER_PROFILE: "/users/user/",
  },
  REPORTS: {
    REPORTS_LIST: "/reports/",
    USER_REPORTS_LIST: "/userReports/",
    REPORT_DETAILS: "/reports/report/",
    USER_REPORT_DETAILS: "/userReports/report/",
    MANAGE_REASONS: "/manage-reasons",
    EXPORT_CSV_FILE: "/reports/export-csv",
  },
  ACCOUNT: {
    MY_ACCOUNT: "/my-account",
    EDIT_MY_ACCOUNT: "/edit-my-account",
  },
  SETTINGS: {
    CONFIGURATIONS: "/settings/configurations",
  },
  RE_ENABLE_ACCOUNT: {
    APPLICATION: "/re-enable-account",
    NEW_APPLICATION: "/reactivate-my-account",
  },
};
export default ROUTEPATH;
